import {
    Button,
    Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Stack,
} from "@chakra-ui/react";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userLogin } from "../../../actions/user_actions";
import Colors from "../../../assets/colors/Colors";
import warnignIcon from "../../../assets/images/Ellipse2.svg";
import email from "../../../assets/images/email.svg";
import password from "../../../assets/images/password.svg";
import {
    GrubAlert,
    GrubFormButton,
    GrubInput,
    GrubTitleText,
    GrubErrorMessage,
    GrubProgress,
} from "../../../components/index";
import { WithRouter } from "../../../navigators/WithRouter";
import BackIconButton from "../components/BackIconButton";
import { useSignIn } from "../hooks/useSignIn";
import * as Constants from "../../../constants/Constants";
const SignIn = (props) => {
    const {
        handleKeyDown,
        formik,
        isSubmittingRef,
        isFocused,
        emailRef,
        errorMessage,
        loading,
        keyboardOpen,
    } = useSignIn(props);
    return (
        <>
            <Modal
                isOpen={props.isOpen}
                onClose={props.onClose}
                size="sm"
                isCentered={!keyboardOpen}
                initialFocusRef={emailRef}
                finalFocusRef={null}
                returnFocusOnClose={false} 
                closeOnEsc={false}
                closeOnOverlayClick={false}
            >
                <ModalOverlay />
                <ModalContent borderRadius="0.63rem">
                    {loading && <GrubProgress />}
                    <ModalBody
                        pl={{ base: "2.56rem", md: "2.56rem" }}
                        pr={{ base: "2.56rem", md: "2.56rem" }}
                        pb={{ base: "4.13rem", md: "4.13rem" }}
                        pt={{ base: "1.88rem", md: "1.88rem" }}
                    >
                        <BackIconButton
                            iconButton={true}
                            onClick={(e) => {
                                e.preventDefault();
                                props.handleBackButton(false);
                            }}
                        />
                        <GrubTitleText
                            isLabelText={true}
                            color={Colors.posTextInfo}
                            name={"Sign In"}
                        />
                        <Button
                            variant="link"
                            onClick={(e) => {
                                e.preventDefault();
                                props.handleSignUpOpen();
                            }}
                            fontStyle="normal"
                            fontWeight={300}
                            fontSize="0.75rem"
                            lineHeight="0.94rem"
                            letterSpacing="-0.01rem"
                            color={Colors.primeTaxInfo}
                        >
                            Don't have an account?
                        </Button>
                        <Stack
                            mt={{ base: "1.5rem", md: "1.5rem" }}
                            spacing={2}
                        >
                            <GrubInput
                                id="email"
                                ref={emailRef}
                                placeholder={"Email Address"}
                                handleInputChange={formik.handleChange}
                                inputValue={formik.values.email || ""}
                                autoFocus={isFocused}
                                handleBlur={(e) => {
                                    setTimeout(() => {
                                        if (emailRef.current) {
                                            formik.setFieldValue("email", formik.values.email.trim());
                                            formik.handleBlur(e);
                                            isSubmittingRef.current = true;
                                        }
                                    }, Constants.TIMEOUT_DELAY); // Delay execution to allow click event to register first
                                }}
                                width={"18.63rem"}
                                posInputGroup={true}
                                darkPlaceholder={true}
                                onKeyDown={(e) => handleKeyDown(e, "password")}
                                background={Colors.posviewbgcolor}
                                inputType={"text"}
                                inputError={
                                    formik.touched.email && formik.errors.email
                                }
                            >
                                <Image src={email} width={"0.99rem"} />
                            </GrubInput>
                            {formik.touched.email && formik.errors.email && (
                                <GrubAlert
                                    width={"100%"}
                                    alertStatus={"error"}
                                    alertTitle={""}
                                    image={warnignIcon}
                                    bg={Colors.errorsign}
                                    color={Colors.orangeButton} 
                                    alertDescription={formik.errors.email}
                                />
                            )}
                            <GrubInput
                                id="password"
                                placeholder={"Password"}
                                handleInputChange={formik.handleChange}
                                inputValue={formik.values.password || ""}
                                handleBlur={(e) => {
                                    setTimeout(() => {
                                        formik.setFieldValue("password", formik.values.password.trim());
                                        formik.handleBlur(e);
                                        isSubmittingRef.current = true;
                                    }, Constants.TIMEOUT_DELAY);
                                }}
                                width={"18.63rem"}
                                posInputGroup={true}
                                darkPlaceholder={true}
                                onKeyDown={(e) => handleKeyDown(e, "submit")}
                                background={Colors.posviewbgcolor}
                                inputType={"password"}
                                inputError={
                                    formik.touched.password &&
                                    formik.errors.password
                                }
                            >
                                <Image src={password} width={"0.99rem"} />
                            </GrubInput>
                            {formik.touched.password &&
                                formik.errors.password && (
                                    <GrubAlert
                                        width={"100%"}
                                        alertStatus={"error"}
                                        alertTitle={""}
                                        image={warnignIcon}
                                        bg={Colors.errorsign}
                                        color={Colors.orangeButton}
                                        alertDescription={
                                            formik.errors.password
                                        }
                                    />
                                )}
                        </Stack>
                        {errorMessage?.error &&
                            errorMessage?.message?.length > 0 && (
                                <GrubErrorMessage
                                    errorMessage={errorMessage.message}
                                    isError={true}
                                    width={"auto"}
                                />
                            )}
                        <Stack
                            mt={{ base: "2.44rem", md: "2.44rem" }}
                            spacing={2}
                        >
                            <GrubFormButton
                                isDisabled={loading}
                                bg={Colors.posTextInfo}
                                buttonsubmit={"Sign In"}
                                width={"18.6rem"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            />
                            <Button
                                variant="link"
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.handleForgotPasswordOpen();
                                }}
                                fontStyle="normal"
                                fontWeight={300}
                                fontSize="0.94rem"
                                lineHeight="1.41rem"
                                letterSpacing="-0.01rem"
                                color={Colors.primeTaxInfo}
                                display="flex"
                                justifyContent="flex-start"
                                alignItems="start"
                            >
                                Forgot Password?
                            </Button>
                        </Stack>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            userLogin,
        },
        dispatch
    );
}
function mapStateToProps(state) {
    return {
        user: state.user,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(SignIn));
